'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Compare = require('./Compare.css');

var _Compare2 = _interopRequireDefault(_Compare);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noTransform = function noTransform(v) {
  return v;
};

var checkmarkTransform = function checkmarkTransform(v) {
  return _react2.default.createElement(_components.YesNo, { yes: _convert2.default.boolean(v) });
};

var yesNoTransform = function yesNoTransform(v) {
  return v === 'true' ? 'Yes' : 'No';
};

var ussifTransform = function ussifTransform(v) {
  var ussifLogo = require('../../../static/images/ussif-icon.png');
  var altText = 'Member of the Forum for Sustainable and Responsible ' + 'Investing';
  var transformed = v !== '1.5' ? 'No' : _react2.default.createElement('img', { styleName: 'ussif', src: ussifLogo, alt: altText });
  return transformed;
};

var moneyTransform = function moneyTransform(v) {
  return _format2.default.money(v, true, 'USD');
};

var expenseRatioTransform = function expenseRatioTransform(v) {
  console.log('expenseRatioTransform');
  console.log(v);
  return v;
};

var gradeTransform = function gradeTransform(v) {
  return _react2.default.createElement(_components.Grade, { grade: v });
};

var getBenchmark = function getBenchmark(v) {
  var findBenchByLabel = function findBenchByLabel(label, benchmarks) {
    return benchmarks.filter(function (benchmark) {
      return label === benchmark.label;
    });
  };
  var getInitBench = function getInitBench(suggested, benchmarks) {
    switch (suggested) {
      case 'MSCI ACWI NR USD':
        return findBenchByLabel('ACWI - iShares MSCI ACWI ETF', benchmarks);
      case 'MSCI ACWI Ex USA NR USD':
        return findBenchByLabel('ACWX - iShares MSCI ACWI ex U.S. ETF', benchmarks);
      default:
        return findBenchByLabel('IVV - iShares Core S&P 500 ETF', benchmarks);
    }
  };
  // all benchmarks in config, but only those w/ 10-yr returns
  var benchmarks = _config2.default.coreBenchmarks.concat(_config2.default.extendedBenchmarks);
  var benchmarksWithPerf = benchmarks.filter(function (b) {
    return b.trailing_return_y10 !== '';
  });
  // choose first benchmark based on shareclass suggested benchmark
  var initBench = getInitBench(v, benchmarksWithPerf).pop();
  return initBench;
};

var etfBenchmarkTransform = function etfBenchmarkTransform(v) {
  var initBench = getBenchmark(v);
  return initBench ? initBench.label : 'ERR-BENCH';
};

/**
 * Format return figures to be shown in the table
 * @param {number} val
 * @return <span> with text
 */
var returnsTransform = function returnsTransform(val) {
  if (!val || val === -1000.0) {
    return _react2.default.createElement(
      'span',
      null,
      '-'
    );
  }
  var valToFixed = (Math.round(val * 100) / 100.0).toFixed(2);

  // if val is above zero, add a plus sign, make it green
  if (val > 0.0) {
    return _react2.default.createElement(
      'span',
      { styleName: 'green' },
      '+',
      valToFixed
    );
  }

  // val is below zero or equal, minus will be shown automatically, make
  // it red
  if (val <= 0.0) {
    return _react2.default.createElement(
      'span',
      { styleName: 'red' },
      valToFixed
    );
  }

  // we should never reach here
  return _react2.default.createElement(
    'span',
    null,
    'ERR'
  );
};

var etfBenchmarkReturnsTransform = function etfBenchmarkReturnsTransform(v, field, modifier, modifierValue) {
  if (modifier === 'benchmark') {
    var initBench = getBenchmark(modifierValue);
    return returnsTransform(initBench[field]);
  } else if (modifier === 'benchmarkDiff') {
    var _initBench = getBenchmark(modifierValue);
    if (v && v !== -1000.0 && v === _initBench[field]) {
      return _react2.default.createElement(
        'span',
        null,
        'N/A'
      );
    }
    if (!v || v === -1000.0) {
      return _react2.default.createElement(
        'span',
        null,
        '-'
      );
    }
    return returnsTransform(v - _initBench[field]);
  }
};

var investmentVehicleIdLength = 10;
var SlotIndexes = [1, 2, 3, 4];
var Sections = [{
  sectionLabel: 'Shareclass overview',
  sectionLabelTooltip: 'A basic overview of the selected shareclasses.',
  sectionRows: [{
    object: 'shareclass',
    label: 'Shareclass ticker',
    field: 'ticker'
  }, {
    object: 'shareclass',
    label: 'Shareclass type',
    field: 'legal_type',
    transform: _format2.default.legalType
  }, {
    label: 'Fund name',
    field: 'fund_legal_name'
  }, {
    label: 'Fund family',
    field: 'fund_family_name',
    href: _config2.default.routes.families,
    query: 'q'
  }, {
    label: 'Sustainability mandate',
    field: 'socially_responsible_fund',
    transform: checkmarkTransform
  }, {
    label: 'US-SIF member',
    field: 'ussif',
    tooltip: 'The Forum for Responsible and Sustainable Investment ' + '(US-SIF) is a group advancing sustainable, responsible, and ' + 'impact investing.',
    transform: ussifTransform
  }, {
    label: 'Fund holdings as of date',
    field: 'date',
    transform: _format2.default.formatDate
  }, {
    label: 'Fund group',
    field: 'category_group'
  }, {
    label: 'Fund category',
    field: 'morningstar_category_name'
  }, {
    label: 'Non-diversification risk',
    field: 'non_diversified_fund',
    transform: yesNoTransform
  }, {
    label: 'Fund inception date',
    field: 'oldest_inception_date',
    transform: _format2.default.formatDate
  }, {
    object: 'shareclass',
    label: 'Shareclass inception date',
    field: 'inception_date',
    transform: _format2.default.formatDate
  }, {
    label: 'Fund net assets',
    field: 'fund_net_assets',
    align: 'r',
    transform: moneyTransform
  }, {
    object: 'shareclass',
    label: 'Prospectus net expense ratio',
    field: 'prospectus_net_expense_ratio',
    align: 'r',
    transform: expenseRatioTransform
  }, {
    label: 'Number of holdings',
    field: 'number_of_holding',
    align: 'r'
  }, {
    label: 'Percent invested in stocks',
    field: 'percent_rated',
    align: 'r',
    transform: _format2.default.perc
  }]
}, {
  sectionLabel: 'Invest Your Values grades',
  sectionLabelTooltip: 'Each shareclass is assigned a grade for six ' + 'environmental and social issues tracked by Invest Your Values. ' + 'Click any grade to see details on how it was calculated for that ' + 'shareclass.',
  sectionRows: [{
    object: 'shareclass',
    label: 'Fossil fuels',
    sublabel: 'Investments in coal, oil, and gas energy and utility ' + 'companies',
    field: 'grade_fossil',
    href: _config2.default.links.fff,
    path: 'fossil-fuel-investments',
    title: ' | Fossil Free Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Deforestation',
    sublabel: 'Investments in deforestation-driving commodities, and ' + 'related financial companies and consumer brands',
    field: 'grade_deforestation',
    href: _config2.default.links.dff,
    path: 'profile',
    title: ' | Deforestation Free Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Gender equality',
    sublabel: 'Overall gender equality score group ranking',
    field: 'grade_gender_equality',
    href: _config2.default.links.gef,
    path: 'gender-lens-score',
    title: ' | Gender Equality Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Civilian firearms',
    sublabel: 'Investments in civilian firearms manufacturers and ' + 'retailers',
    field: 'grade_guns',
    href: _config2.default.links.gff,
    path: 'gun-investments',
    title: ' | Gun Free Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Prison industrial complex',
    sublabel: 'Investments in companies involved in the prison and ' + 'border industries',
    field: 'grade_prison_industrial_complex',
    href: _config2.default.links.pff,
    path: 'prison-industrial-complex-investments',
    title: ' | Prison Free Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Military weapons',
    sublabel: 'Investments in military arms manufacturers and services ' + 'companies',
    field: 'grade_military',
    href: _config2.default.links.wff,
    path: 'weapon-investments',
    title: ' | Weapon Free Funds',
    transform: gradeTransform
  }, {
    object: 'shareclass',
    label: 'Tobacco',
    sublabel: 'Investments in tobacco and e-cigarette manufacturers, ' + 'and tobacco-promoting entertainment studios',
    field: 'grade_tobacco',
    href: _config2.default.links.tff,
    path: 'tobacco-profile',
    title: ' | Tobacco Free Funds',
    transform: gradeTransform
  }]
}, {
  sectionLabel: 'Performance overview',
  sectionLabelTooltip: 'An overview of financial performance. All ' + 'returns are trailing month end annualized returns, net of expenses ' + 'but not fees.',
  sectionRows: [{
    object: 'shareclass',
    label: 'Performance as of date',
    field: 'performance_as_of_date',
    transform: _format2.default.formatDate
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 1 month',
    field: 'trailing_return_m1',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 3 months',
    field: 'trailing_return_m3',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 6 months',
    field: 'trailing_return_m6',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 1 year',
    field: 'trailing_return_y1',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 3 year',
    field: 'trailing_return_y3',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 5 year',
    field: 'trailing_return_y5',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 10 year',
    field: 'trailing_return_y10',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 15 year',
    field: 'trailing_return_y15',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, 20 year',
    field: 'trailing_return_y20',
    align: 'r',
    transform: returnsTransform
  }, {
    object: 'shareclass',
    label: 'Annualized returns, year-to-date',
    field: 'trailing_return_ytd',
    align: 'r',
    transform: returnsTransform
  }]
}, {
  sectionLabel: 'Benchmarked performance',
  sectionLabelTooltip: 'An overview of financial performance compared to ' + 'a benchmark. All returns are trailing month end annualized returns, ' + 'net of expenses but not fees.',
  sectionRows: [{
    label: 'Morningstar suggested benchmark',
    field: 'morningstar_primary_benchmark'
  }, {
    label: 'iShares index ETF benchmark',
    field: 'morningstar_primary_benchmark',
    tooltip: 'Shareclasses are assigned a benchmark ETF by Invest Your ' + 'Values. Each shareclass is assigned to an iShares index fund ' + 'ETF that tracks the Morningstar suggested benchmark.',
    transform: etfBenchmarkTransform
  },
  // {
  //   object: 'shareclass',
  //   label: 'Benchmark annualized returns, 1 year',
  //   field: 'trailing_return_y1',
  //   transform: etfBenchmarkReturnsTransform,
  //   modifier: 'benchmark',
  //   modifierField: 'morningstar_primary_benchmark'
  // },
  // {
  //   object: 'shareclass',
  //   label: 'Benchmark annualized returns, 3 year',
  //   field: 'trailing_return_y3',
  //   transform: etfBenchmarkReturnsTransform,
  //   modifier: 'benchmark',
  //   modifierField: 'morningstar_primary_benchmark'
  // },
  // {
  //   object: 'shareclass',
  //   label: 'Benchmark annualized returns, 5 year',
  //   field: 'trailing_return_y5',
  //   transform: etfBenchmarkReturnsTransform,
  //   modifier: 'benchmark',
  //   modifierField: 'morningstar_primary_benchmark'
  // },
  // {
  //   object: 'shareclass',
  //   label: 'Benchmark annualized returns, 10 year',
  //   field: 'trailing_return_y10',
  //   transform: etfBenchmarkReturnsTransform,
  //   modifier: 'benchmark',
  //   modifierField: 'morningstar_primary_benchmark'
  // },
  {
    object: 'shareclass',
    label: '+/- compared to benchmark, 1 year',
    field: 'trailing_return_y1',
    align: 'r',
    transform: etfBenchmarkReturnsTransform,
    modifier: 'benchmarkDiff',
    modifierField: 'morningstar_primary_benchmark'
  }, {
    object: 'shareclass',
    label: '+/- compared to benchmark, 3 year',
    field: 'trailing_return_y3',
    align: 'r',
    transform: etfBenchmarkReturnsTransform,
    modifier: 'benchmarkDiff',
    modifierField: 'morningstar_primary_benchmark'
  }, {
    object: 'shareclass',
    label: '+/- compared to benchmark, 5 year',
    field: 'trailing_return_y5',
    align: 'r',
    transform: etfBenchmarkReturnsTransform,
    modifier: 'benchmarkDiff',
    modifierField: 'morningstar_primary_benchmark'
  }, {
    object: 'shareclass',
    label: '+/- compared to benchmark, 10 year',
    field: 'trailing_return_y10',
    align: 'r',
    transform: etfBenchmarkReturnsTransform,
    modifier: 'benchmarkDiff',
    modifierField: 'morningstar_primary_benchmark'
  }]
}];
// set defaults for each section row
var Defaults = {
  transform: noTransform,
  object: 'fund',
  href: null,
  path: null,
  title: null,
  query: null,
  tooltip: null,
  modifier: null,
  modifierField: null,
  align: null
};
Sections.forEach(function (section, sectionIndex) {
  // for each section:
  section.sectionRows.forEach(function (sectionRow, sectionRowIndex) {
    // for each section row:
    var defaultKeys = (0, _keys2.default)(Defaults);
    defaultKeys.forEach(function (defaultKey, defaultKeyIdx) {
      // for each field in the defaults object:
      if (!sectionRow[defaultKey]) {
        // if, in this row of this section, a value wasn't set for this field:
        // set the value to the default
        sectionRow[defaultKey] = Defaults[defaultKey];
      }
    });
  });
});

// convert query props to state
var stateFromProps = function stateFromProps(props) {
  // s1, s2, etc. are investment_vehicle_ids that define which shareclasses
  // are placed in each slot of the cart
  var state = {
    s1: 'N',
    s2: 'N',
    s3: 'N',
    s4: 'N',
    location: props.location
  };
  SlotIndexes.forEach(function (idx) {
    // for each of the slot indexes (1,2,3,4):
    // we'll check to see if that query is present in the location
    var sIdx = 's' + idx.toString();
    if (props.location.query[sIdx]) {
      // if there is are ?s1=, &s2= queries in the location:
      var sId = props.location.query[sIdx];
      if (typeof sId !== 'undefined' && sId !== null && sId.length === investmentVehicleIdLength) {
        // if the query value exists as well, and is length 10:
        // (all investment_vehicle_ids are strings with 10 characters)
        // set this investment_vehicle_id as the value for the related slot
        state[sIdx] = sId;
      }
    }
  });
  // empty out the slots object, and null the lastResult object
  state = (0, _assign2.default)(state, {
    slots: {},
    lastResult: null
  });
  // we now have a state with empty slots, null lastResult, and s1 through s4
  // with investment_vehicle_id if they were present in the location queries,
  // 'N' (null sentinel) if not.
  return state;
};

var Compare = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.compare.result,
    loading: state.compare.loading,
    loaded: state.compare.loaded,
    error: state.compare.error,
    cart: state.cart.result
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_Compare2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Compare, _Component);

  function Compare(props) {
    (0, _classCallCheck3.default)(this, Compare);

    // use stateFromProps() to gather s1, s2, etc. queries from URL for state
    var _this = (0, _possibleConstructorReturn3.default)(this, (Compare.__proto__ || (0, _getPrototypeOf2.default)(Compare)).call(this, props));

    _this.scrollTop = function () {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    };

    _this.compareShareclasses = function (state) {
      // call the API. props.compareShareclasses() takes up to 4 investment
      // vehicle ids and calls /shareclasses to get shareclass, fund, and
      // sibling shareclass objects. when API call has resolved,
      // componentWillReceiveProps() will handle state management.
      _this.props.compareShareclasses(state.s1, state.s2, state.s3, state.s4);
    };

    _this.replaceShareclass = function (shareclass) {
      // click handler for "replace" link. removes this shareclass from the
      // cart, and navigates to the search page. when user gets to the search
      // page, the "replaced" shareclass will be an empty slot, but the other
      // slots will remain as they were (empty or filled).
      // 
      // props.cartChange() takes a cart array and a new shareclass to add or
      // remove. in this case, we want to remove the selected shareclass from
      // the existing cart.
      _this.props.cartChange(_this.props.cart.results, shareclass);
      // navigate to search page
      _this.context.router.push(_config2.default.routes.clean);
    };

    _this.generateProfileUrl = function (shareclass) {
      // make ticker safe for URL
      var sTicker = shareclass.ticker || 'N';
      // build a profile URL
      var profileUrl = _config2.default.routes.fund + '/' + _format2.default.sanitize(shareclass.fund_legal_name) + '/' + sTicker + '/' + _config2.default.profilePath + '/' + shareclass.fund_id + '/' + shareclass.investment_vehicle_id;
      return profileUrl;
    };

    _this.renderValue = function (row, slotIndex) {
      if (row.object && // we have an object defined, fund or shareclass
      row.field && // we have a field name
      row.transform && // we have a transform function
      _this.state.slots && // we have our slots filled by the API results
      _this.state.slots[slotIndex] && // this slot is filled
      _this.state.slots[slotIndex][row.object] && // this slot has the object
      _this.state.slots[slotIndex][row.object][row.field] // this obj has field
      ) {
          var obj = _this.state.slots[slotIndex][row.object];
          var value = obj[row.field];
          var transformed = null;
          if (row.modifier) {
            // if there's a modifier, the transform function takes more values
            transformed = row.transform(value, row.field, row.modifier, obj[row.modifierField]);
          } else {
            transformed = row.transform(value);
          }

          // dealing with links
          // some links are direct URLs. others need to use the provided value
          // and provided query name to change the href and the title
          // 
          // is there an href?
          var href = row.href,
              title = row.title;
          var query = row.query,
              path = row.path;

          var strong = true;
          if (href) {
            // we have an href
            if (query) {
              // if there's an href AND a query:
              // we'll make a safe version of the value for the query
              var safeQueryValue = encodeURIComponent(value);
              href = href + '?' + query + '=' + safeQueryValue;
              title = transformed + ' | ' + _config2.default.app.title;
            } else if (path) {
              // if there's an href AND a path AND no query
              // that means we're going to one of the other IYV sites
              var sTicker = obj.ticker || 'N';
              var sName = _format2.default.sanitize(obj.fund_legal_name);
              href = href + '/fund/' + sName + '/' + sTicker + '/' + path + '/' + obj.fund_id + '/' + obj.investment_vehicle_id;
              title = obj.fund_legal_name + title;
              strong = false;
            }
            return _react2.default.createElement(
              _components.Link,
              { to: href, title: title || '--', strong: strong },
              transformed
            );
          } else {
            // there's no href. return the transformed value with no link
            return transformed;
          }
        } else {
        // there's no value. return nothing
        return _react2.default.createElement(
          'div',
          { styleName: 'empty-cell' },
          '/'
        );
      }
    };

    _this.renderCartRow = function () {
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'cart-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { styleName: 'cart-col', xs: 12, sm: 3 },
          _react2.default.createElement(
            'div',
            null,
            'Select shareclasses',
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _components.Link,
              { to: _config2.default.routes.clean, xstrong: true },
              _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-angle-double-left' }),
              'Back to search'
            )
          )
        ),
        /* render each slot of the cart */
        SlotIndexes.map(function (slotIndex, slotIndexIdx) {
          if (_this.state.slots[slotIndex] && _this.state.slots[slotIndex].shareclass && _this.state.slots[slotIndex].fund) {
            var _this$state$slots$slo = _this.state.slots[slotIndex],
                shareclass = _this$state$slots$slo.shareclass,
                fund = _this$state$slots$slo.fund;
            var fund_legal_name = shareclass.fund_legal_name,
                fund_id = shareclass.fund_id,
                fund_family_name = shareclass.fund_family_name,
                name = shareclass.name,
                investment_vehicle_id = shareclass.investment_vehicle_id;

            // build a profile URL

            var profileUrl = _this.generateProfileUrl(shareclass);

            var familyUrl = _config2.default.routes.families + '?q=' + fund_family_name;

            // build a remove URL
            // we want to remember the existing slot ids
            var saveSlotIds = {};
            SlotIndexes.forEach(function (sltIndx) {
              var sltIndexString = 's' + sltIndx.toString();
              if (_this.state[sltIndexString]) {
                saveSlotIds[sltIndx] = _this.state[sltIndexString];
              }
            });
            // zero out this slot id
            saveSlotIds[slotIndex] = 'N';
            var removeUrl = _config2.default.routes.compare + '?';

            SlotIndexes.forEach(function (sltIndx) {
              if (saveSlotIds[sltIndx] && saveSlotIds[sltIndx] !== 'N') {
                removeUrl = removeUrl + 's' + sltIndx + '=' + saveSlotIds[sltIndx] + '&';
              }
            });

            var fileName = _format2.default.imgPath(fund_family_name);
            var hasLogo = false;
            var companyLogo = null;
            try {
              companyLogo = require('../../../static/images/fam/' + fileName + '.png');
              hasLogo = true;
            } catch (e) {
              console.log('');
            }

            return _react2.default.createElement(
              _reactFlexboxGrid.Col,
              {
                styleName: 'cart-col',
                xs: 12,
                sm: 2.25,
                key: 'cart-col-header-' + slotIndexIdx
              },
              _react2.default.createElement(
                'div',
                { styleName: 'cart-title' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'section-name' },
                  name
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'section-ticker' },
                  shareclass.ticker || null
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'no-bold' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: profileUrl,
                      title: name + ' | ' + _config2.default.app.title,
                      xstrong: true
                    },
                    'Profile',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                _components.Link,
                {
                  to: familyUrl,
                  title: fund_family_name + ' | ' + _config2.default.app.title,
                  strong: true
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'cart-image' },
                  /* show a logo image if there is one*/
                  hasLogo ? _react2.default.createElement('img', {
                    styleName: 'name-logo',
                    src: companyLogo,
                    alt: fund_family_name
                  }) : _react2.default.createElement(
                    'span',
                    null,
                    fund_family_name
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'cart-subtitle' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: removeUrl,
                    title: 'Remove ' + name,
                    strong: true
                  },
                  'Remove',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-minus-square-o' })
                ),
                '\xA0|\xA0',
                _react2.default.createElement(
                  'span',
                  {
                    onClick: function onClick() {
                      _this.replaceShareclass(shareclass);
                    },
                    title: 'Replace ' + name,
                    styleName: 'cart-subtitle-link'
                  },
                  'Replace',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-undo' })
                )
              )
            );
          } else {
            return _react2.default.createElement(
              _reactFlexboxGrid.Col,
              {
                styleName: 'cart-col',
                xs: 12,
                sm: 2.25,
                key: 'cart-col-header-' + slotIndexIdx
              },
              _react2.default.createElement('div', { styleName: 'cart-title' }),
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.clean,
                  title: 'Add shareclass | Compare funds | ' + _config2.default.app.title,
                  styleName: 'cart-image'
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-plus-square-o fa-3x' })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'cart-subtitle' },
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.clean, strong: true },
                  'Add shareclass'
                )
              )
            );
          }
        })
      );
    };

    var initState = stateFromProps(props);
    _this.state = initState;
    return _this;
  }

  (0, _createClass3.default)(Compare, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.scrollTop();
      // search for the shareclasses specified in state
      this.compareShareclasses(this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      this.scrollTop();
      if (props.location !== this.state.location) {
        // if the location changed:
        // trigger a new search. first collect query ids 
        var state = (0, _assign2.default)(this.state, stateFromProps(props));
        // set state with empty slots, null lastResult, and query-defined s1...
        this.setState(state);
        // search again
        this.compareShareclasses(state);
      } else if (
      // else if results are present, and results are new:
      props.result && props.result.results && this.state.lastResult !== props.result.results) {
        var slots = {};
        var cart = [];
        SlotIndexes.forEach(function (slotIndex) {
          // do we have a shareclass id in state, from URL query?
          var slotIndexName = 's' + slotIndex.toString();
          var shareclassId = _this2.state[slotIndexName];
          shareclassId = shareclassId !== 'N' ? shareclassId : null;
          var sArr = props.result.results.filter(function (s) {
            return s.investment_vehicle_id === shareclassId;
          });
          // unpack the shareclass, fund, and siblings, assuming they exist
          var sShareclass = sArr && sArr.length ? sArr[0] : null;
          var sFund = sShareclass ? sShareclass.fund || null : null;
          var sSiblings = sFund ? sFund.shareclass || null : null;
          // fill slots
          slots[slotIndex] = {
            'shareclass': sShareclass,
            'fund': sFund,
            'siblings': sSiblings
          };
          if (sShareclass && sShareclass.investment_vehicle_id) {
            cart.push({
              id: sShareclass.investment_vehicle_id,
              shareclassStub: {
                name: sShareclass.name,
                ticker: sShareclass.ticker,
                fund_id: sShareclass.fund_id,
                investment_vehicle_id: sShareclass.investment_vehicle_id,
                fund_legal_name: sShareclass.fund_legal_name,
                fund_family_name: sShareclass.fund_family_name
              }
            });
          } else {
            cart.push({
              id: 'N',
              shareclassStub: {}
            });
          }
        });
        this.setState({
          lastResult: props.result.results,
          slots: slots
          // shareclasses: this.state.shareclasses.concat(props.result.results)
        });
        // set these funds (defined from URL query) as the stored cart
        this.props.cartChange(cart, 'N');
      } else if (props.result && props.result.results && this.state.lastResult === props.result.results) {
        // chill
        // console.log('we are here')
      } else {
          // const state = Object.assign(this.state, stateFromProps(props))
          // // set state
          // this.setState(state)
          // // search again
          // this.compareShareclasses(state)
        }
    }

    // render a value from the Sections table.
    // values need to exist; need to have a link rendered if needed;

  }, {
    key: 'render',


    /**
     * Main render function
     * @return {JSX} page component
     */
    value: function render() {
      var _this3 = this;

      if (!this.props.result || !this.state.slots) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.results || !this.props.result.results.length)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var title = 'Compare';
      var url = _config2.default.domain + _config2.default.routes.compare;
      var sriIcon = require('../../../static/images/sri.svg');
      var ussifLogo = require('../../../static/images/ussif-icon.png');
      // const overallScoreIcon = require( '../../../static/images/GEF-icons-gender-equality-score.svg' )
      // const rankIcon = require( '../../../static/images/GEF-icons-peer-rank.svg' )
      // const balanceIcon = require( '../../../static/images/GEF-icons-gender-balance-score.svg' )
      // const policiesIcon = require( '../../../static/images/GEF-icons-gender-equality-policies-rank.svg' )
      // const upArrow = require( '../../../static/images/holdings-up-arrow.svg' )
      // const downArrow = require( '../../../static/images/holdings-down-arrow.svg' )

      // tmp tmp tmp
      var s1Fund = this.state.slots[1];
      var s2Fund = this.state.slots[2];

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'container-inner visible-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'not-yet-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'not-yet-headline' },
                'Fund compare is coming soon to mobile!'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'not-yet-info' },
                'We\'re working hard to bring this feature to mobile. For now, try visiting this page on your tablet or desktop browser.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'not-yet-back' },
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.clean, xstrong: true },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-angle-double-left' }),
                  'Back to search'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'container-inner hidden-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'page-title' },
              'Compare funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'page-info' },
              'Select shareclasses and compare. See how funds are graded on fossil fuels, deforestation, gender equality, and other environmental and social issues, side-by-side. You can also compare shareclasses on financial performance.'
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            this.renderCartRow(),
            _react2.default.createElement('div', { styleName: 'line' }),
            /* render each section */
            Sections.map(function (section, sectionIdx) {
              return _react2.default.createElement(
                'div',
                {
                  styleName: 'data-section-wrap',
                  key: 'data-section-wrap-' + sectionIdx
                },
                _react2.default.createElement('div', { styleName: 'data-section-head' }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'data-section' },
                  _react2.default.createElement(
                    _reactFlexboxGrid.Row,
                    { styleName: 'data-section-row' },
                    _react2.default.createElement(
                      _reactFlexboxGrid.Col,
                      { styleName: 'data-section-col', xs: 12 },
                      /* is there a tooltip for the section? 
                         if so wrap the section label in a <span> with
                         the tooltip, and include a ReactTooltip */
                      section.sectionLabelTooltip ? _react2.default.createElement(
                        'span',
                        {
                          'data-multiline': true,
                          'data-effect': 'solid',
                          'data-tip': '\n                                    <div style=\'max-width:250px;\'>\n                                      ' + section.sectionLabelTooltip + '\n                                    </div>\n                                  ',
                          'data-html': true,
                          'data-place': 'right',
                          'data-for': 'data-section-label-' + sectionIdx
                        },
                        section.sectionLabel,
                        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
                        _react2.default.createElement(_reactTooltip2.default, {
                          id: 'data-section-label-' + sectionIdx
                        })
                      ) : section.sectionLabel
                    ),
                    _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 3 }),
                    /* render each slot for this row */
                    SlotIndexes.map(function (slotIndex, slotIndexIdx) {
                      var display = _this3.state.slots[slotIndex] && _this3.state.slots[slotIndex].shareclass;
                      var sh = null;
                      if (display) {
                        sh = _this3.state.slots[slotIndex].shareclass;
                      }
                      return _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        {
                          styleName: 'data-section-col',
                          xs: 12,
                          sm: 2.25,
                          key: 'data-section-col-' + sectionIdx + '-header-' + slotIndexIdx
                        },
                        /* is there a shareclass to display? */
                        display ? _react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(
                            'span',
                            { styleName: 'section-name' },
                            sh.name || '-'
                          ),
                          _react2.default.createElement(
                            'span',
                            { styleName: 'section-ticker' },
                            sh.ticker || null
                          ),
                          _react2.default.createElement(
                            'span',
                            { styleName: 'no-bold' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _this3.generateProfileUrl(sh),
                                title: sh.name + ' | ' + _config2.default.app.title,
                                xstrong: true
                              },
                              'Profile',
                              _react2.default.createElement(_components.LinkIcon, { nospace: true })
                            )
                          )
                        ) : null
                      );
                    })
                    /* end slot map */
                  ),
                  /* render each row for this section */
                  section.sectionRows.map(function (row, rowIdx) {
                    return _react2.default.createElement(
                      _reactFlexboxGrid.Row,
                      {
                        styleName: 'data-section-row',
                        key: 'data-section-row-' + sectionIdx + '-' + rowIdx
                      },
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { styleName: 'data-section-col', xs: 12, sm: 3 },
                        /* is there a tooltip for the row label? 
                           if so wrap the row.label in a <span> with
                           a tooltip, and include a ReactTooltip */
                        row.tooltip ? _react2.default.createElement(
                          'span',
                          {
                            styleName: 'data-section-row-label',
                            'data-multiline': true,
                            'data-effect': 'solid',
                            'data-tip': '\n                                          <div style=\'max-width:250px;\'>\n                                            ' + row.tooltip + '\n                                          </div>\n                                        ',
                            'data-html': true,
                            'data-place': 'right',
                            'data-for': 'data-section-row-' + sectionIdx + '-' + rowIdx
                          },
                          row.label,
                          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
                          _react2.default.createElement(_reactTooltip2.default, {
                            id: 'data-section-row-' + sectionIdx + '-' + rowIdx
                          })
                        ) : _react2.default.createElement(
                          'span',
                          {
                            styleName: 'data-section-row-label'
                          },
                          row.label
                        ),
                        /* is there a sublabel? */
                        row.sublabel ? _react2.default.createElement(
                          'span',
                          {
                            styleName: 'data-section-row-sublabel'
                          },
                          row.sublabel
                        ) : null
                      ),
                      /* render each slot for this row */
                      SlotIndexes.map(function (slotIndex, slotIndexIdx) {
                        var style = row.align ? 'col-align-' + row.align : 'col-align-l';
                        return _react2.default.createElement(
                          _reactFlexboxGrid.Col,
                          {
                            styleName: 'data-section-col ' + style,
                            xs: 12,
                            sm: 2.25,
                            key: 'data-section-col-' + sectionIdx + '-' + rowIdx + '-' + slotIndexIdx
                          },
                          _this3.renderValue(row, slotIndex)
                        );
                      })
                      /* end slot map */
                    );
                  })
                  /* end row map */
                ),
                _react2.default.createElement('div', { styleName: 'data-section-tail' })
              );
            })
            /* end section map */,
            _react2.default.createElement(
              'div',
              { styleName: 'page-tail' },
              'Select new funds to compare'
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            this.renderCartRow(),
            _react2.default.createElement('div', { styleName: 'line' })
          )
        )
      );
    }
  }]);
  return Compare;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object,
  compare: _react.PropTypes.func,
  cart: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = Compare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Compare/Compare.js
// module id = 1330
// module chunks = 0